import { ApiEndpoint } from "@/app/apiEndpoint";
import axios from "@/app/http/axios";
import { FormPattern, FormStep } from "@/interface/Form.interface";

export default class AdminFormService {
  constructor() {}

  async getAllForms() {
    const path = ApiEndpoint.AdminForm.GET_ALL;
    try {
      const response = await axios.get<FormPattern[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getFormsWithConditions(filter: any) {
    const path = ApiEndpoint.AdminForm.SEARCH;
    try {
      const response = await axios.post<FormPattern[]>(`${path}`, filter);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getFormById(id: number) {
    const path = ApiEndpoint.AdminForm.GET_BY_ID;
    try {
      const response = await axios.get<FormPattern>(
        `${path.replace("{id}", id.toString())}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async createForm(value: any) {
    const path = ApiEndpoint.AdminForm.CREATE;
    try {
      const response = await axios.post(`${path}`, value);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async updateForm(id: number, value: any) {
    const path = ApiEndpoint.AdminForm.UPDATE;
    try {
      const response = await axios.patch(
        `${path.replace("{id}", id.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async updateFormStatus(id: number, value: any) {
    const path = ApiEndpoint.AdminForm.UPDATE_STATUS;
    try {
      const response = await axios.patch(
        `${path.replace("{id}", id.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getAllSteps() {
    const path = ApiEndpoint.AdminForm.GET_ALL_STEPS;
    try {
      const response = await axios.get<FormStep>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}
